import { forEach } from 'ramda';

const createAsyncAction = type => ({
  REQUESTED: `${type}_REQUESTED`,
  PENDING: `${type}_PENDING`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`
});

export const LOGIN = createAsyncAction('LOGIN');
export const FETCH_COMPANIES = createAsyncAction('FETCH_COMPANIES');
export const FETCH_COMPANY = createAsyncAction('FETCH_COMPANY');
export const UPDATE_COMPANY = createAsyncAction('UPDATE_COMPANY');
export const CREATE_COMPANY = createAsyncAction('CREATE_COMPANY');
export const DELETE_COMPANY = createAsyncAction('DELETE_COMPANY');

export const FETCH_ACCOUNT_GROUPS = createAsyncAction('FETCH_ACCOUNT_GROUPS');
export const FETCH_ACCOUNT_GROUP = createAsyncAction('FETCH_ACCOUNT_GROUP');
export const CREATE_ACCOUNT_GROUP = createAsyncAction('CREATE_ACCOUNT_GROUP');
export const UPDATE_ACCOUNT_GROUP = createAsyncAction('UPDATE_ACCOUNT_GROUP');
export const RESET_CURRENT_GROUP = 'RESET_CURRENT_GROUP';

export const FETCH_USERS = createAsyncAction('FETCH_USERS');

export const IMPERSONATE_DASHBOARD_USER = createAsyncAction('IMPERSONATE_DASHBOARD_USER');

export const FETCH_RESULTS = createAsyncAction('FETCH_RESULTS');
export const FETCH_RESULT = createAsyncAction('FETCH_RESULT');
export const FETCH_GAME_EVENTS = createAsyncAction('FETCH_GAME_EVENTS');
export const FETCH_GAME_CONVERSATIONS = createAsyncAction('FETCH_GAME_CONVERSATIONS');

export const FETCH_CHATS_STATS = createAsyncAction('FETCH_CHATS_STATS');
export const FETCH_CHAT_STATS = createAsyncAction('FETCH_CHAT_STATS');
export const CHATS_FILTER_SET = 'CHATS_FILTER_SET';

export const COMPANIES_FILTER_SET = 'COMPANIES_FILTER_SET';
export const COMPANIES_PAGE_SET = 'COMPANIES_PAGE_SET';
export const RESULTS_FILTER_SET = 'RESULTS_FILTER_SET';
export const RESULTS_PAGE_SET = 'RESULTS_PAGE_SET';
export const USERS_FILTER_SET = 'USERS_FILTER_SET';
export const USERS_PAGE_SET = 'USERS_PAGE_SET';
export const IMPERSONATE_USER = createAsyncAction('IMPERSONATE_USER');

export const CURRENT_COMPANY_RESET = 'CURRENT_COMPANY_RESET';

export const API_CALL_STARTED = 'API_CALL_STARTED';
export const API_CALL_FINISHED = 'API_CALL_FINISHED';

export const FETCH_OPPORTUNITIES = createAsyncAction('FETCH_OPPORTUNITIES');
export const FETCH_OPPORTUNITY = createAsyncAction('FETCH_OPPORTUNITY');
export const OPPORTUNITIES_FILTER_SET = 'OPPORTUNITIES_FILTER_SET';
export const UPDATE_OPPORTUNITY = createAsyncAction('UPDATE_OPPORTUNITY');
export const CURRENT_OPPORTUNITY_RESET = 'CURRENT_OPPORTUNITY_RESET';

export const FETCH_TEAMS = createAsyncAction('FETCH_TEAMS');
export const FETCH_TEAM = createAsyncAction('FETCH_TEAM');
export const UPDATE_TEAM = createAsyncAction('UPDATE_TEAM');
export const CREATE_TEAM = createAsyncAction('CREATE_TEAM');
export const DELETE_TEAM = createAsyncAction('DELETE_TEAM');
export const TEAMS_FILTER_SET = 'TEAMS_FILTER_SET';
export const TEAMS_PAGE_SET = 'TEAMS_PAGE_SET';
export const CURRENT_TEAM_RESET = 'CURRENT_TEAM_RESET';

export const LOGOUT = createAsyncAction('LOGOUT');

export const LANGUAGES = [
  {
    value: 'en',
    label: 'English'
  },
  {
    value: 'cs',
    label: 'Čeština'
  },
  {
    value: 'sk',
    label: 'Slovenčina'
  }
];

export const PRICE_PACKAGES = [
  {
    id: 'MINI',
    label: 'Mini'
  },
  {
    id: 'BASIC',
    label: 'Basic'
  },
  {
    id: 'STANDARD',
    label: 'Standard'
  },
  {
    id: 'ADVANCED',
    label: 'Advanced'
  }
];

export const CONTRACT_PLAN_TYPES = [
  {
    value: 'LIMITED',
    label: 'Limited'
  },
  {
    value: 'FREE',
    label: 'Free'
  },
  {
    value: 'STARTER',
    label: 'Starter'
  },
  {
    value: 'PILOT',
    label: 'Pilot'
  },
  {
    value: 'PAID',
    label: 'Paid'
  }
];

export const POSTER_TYPES = [
  { value: null, label: 'None' },
  { value: 'BEHAVERA', label: 'Behavera - standard' },
  { value: 'SKODA', label: 'Skoda' }
];

export const IDENTIFICATION_DATA_ACCESS = [
  {
    value: 'SCRAMBLED',
    label: 'Scrambled'
  },
  {
    value: 'ANONYMIZED',
    label: 'Anonymized'
  },
  {
    value: 'FULL',
    label: 'Full'
  }
];

export const MODALS = {
  ACCOUNT_GROUP_SAVE_CONFIRM: 'ACCOUNT_GROUP_SAVE_CONFIRM',
  COMPANY_SAVE_AND_NOTIFY: 'COMPANY_SAVE_AND_NOTIFY',
  COMPANY_DELETE: 'COMPANY_DELETE',
  OPPORTUNITY_UPLOAD_LINK: 'OPPORTUNITY_UPLOAD_LINK'
};

export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_OPEN = 'MODAL_OPEN';

const BASE_BRAND = {
  email: function (prefix) {
    return `${prefix}@${this.domain}`;
  },
  folder: function () {
    return this.key.toLowerCase();
  }
};

const BRANDS = {
  BEHAVERA: {
    ...BASE_BRAND,
    domain: 'behavera.com',
    label: 'Behavera',
    key: 'BEHAVERA',
    theme: {
      palette: {
        primary1Color: '#46617c',
        primary2Color: '#46617c',
        accent1Color: '#dd4b64',
        pickerHeaderColor: '#46617c',
        projects: {
          cards: {
            active: '#c9d811',
            scheduled: '#db7712',
            finished: '#48be0f',
            concept: '#cccccc'
          }
        }
      },
      tabs: {
        backgroundColor: '#1A395B'
      }
    }
  },
  VIRTUBIO: {
    ...BASE_BRAND,
    domain: 'virtub.io',
    label: 'Virtubio',
    key: 'VIRTUBIO',
    theme: {
      palette: {
        primary1Color: '#049BE5',
        primary2Color: '#029AE4',
        accent1Color: '#FF9700',
        pickerHeaderColor: '#049BE5',
        projects: {
          cards: {
            active: '#4caf50',
            scheduled: '#FF9700',
            finished: '#049BE5',
            concept: '#9e9e9e'
          }
        }
      },
      tabs: {
        backgroundColor: '#0177bc'
      }
    }
  }
};

const determineBrand = () => {
  const host = window.location.host;
  let brand;
  if (host.indexOf('behavera') > -1) {
    brand = BRANDS.BEHAVERA;
  } else if (host.indexOf('virtub') > -1) {
    brand = BRANDS.VIRTUBIO;
  } else {
    brand = BRANDS.BEHAVERA;
  }
  document.title = `Admin | ${brand.label}`;
  const toRemove = [];
  forEach(n => {
    if (n.tagName === 'LINK') {
      const href = n.getAttribute('href');
      if (href.indexOf('/branding') > -1 && href.indexOf(brand.key.toLowerCase()) < 0) {
        toRemove.push(n);
      }
    } else if (n.tagName === 'META') {
      const name = n.getAttribute('name');
      if (
        (name === 'application-name' || name === 'apple-mobile-web-app-title') &&
        n.getAttribute('content') !== brand.label
      ) {
        toRemove.push(n);
      }
    }
  }, document.head.childNodes);
  forEach(n => document.head.removeChild(n), toRemove);
  return brand;
};

export const BRAND = determineBrand();

const createLLMModelItem = (value, label) => ({
  value,
  label
});

export const LLM_MODELS = [
  [
    createLLMModelItem('gemini-2.5-flash', 'Gemini 2.5 Flash'),
    createLLMModelItem('gemini-2.5-flash-lite', 'Gemini 2.5 Flash Lite'),
    createLLMModelItem('gemini-2.5-pro', 'Gemini 2.5 Pro'),
    createLLMModelItem('gemini-2.0-flash', 'Gemini 2.0 Flash'),
    createLLMModelItem('gemini-2.0-flash-lite', 'Gemini 2.0 Flash Lite')
  ],
  [createLLMModelItem('gemini-3-pro-preview', 'Gemini 3.0 Pro Preview')]
];
export const DEFAULT_LLM_MODEL = LLM_MODELS[0][0];



// WEBPACK FOOTER //
// ./src/constants/Constants.js